module.exports = __webpack_public_path__ + "static/the-secrets-in-the-hot-sauce-acf47e71cf1a03e2677791bfbcbdb158.jpg";